import { TimezoneResponse } from '../types'

export const TIMEZONE_LIST: TimezoneResponse[] = [
	{
		name: 'Midway Islands (GMT-11:00)',
		code: 'Pacific/Midway',
		offset: '-1100',
		shortCode: 'SST',
	},
	{
		name: 'Hawaii (GMT-10:00)',
		code: 'Pacific/Honolulu',
		offset: '-1000',
		shortCode: 'HST',
	},
	{
		name: 'Alaska (GMT-09:00)',
		code: 'America/Anchorage',
		offset: '-0900',
		shortCode: 'AKST',
	},
	{
		name: 'Pacific Time (GMT-08:00)',
		code: 'America/Los_Angeles',
		offset: '-0800',
		shortCode: 'PST',
	},
	{
		name: 'Mountain Time (GMT-07:00)',
		code: 'America/Denver',
		offset: '-0700',
		shortCode: 'MST',
	},
	{
		name: 'Central Time (GMT-06:00)',
		code: 'America/Chicago',
		offset: '-0600',
		shortCode: 'CST',
	},
	{
		name: 'Eastern Time (GMT-05:00)',
		code: 'America/New_York',
		offset: '-0500',
		shortCode: 'EST',
	},
	{
		name: 'Atlantic Time (GMT-04:00)',
		code: 'America/Halifax',
		offset: '-0400',
		shortCode: 'AST',
	},
	{
		name: 'Newfoundland (GMT-03:30)',
		code: 'America/St_Johns',
		offset: '-0330',
		shortCode: 'NST',
	},
	{
		name: 'Buenos Aires (GMT-03:00)',
		code: 'America/Argentina/Buenos_Aires',
		offset: '-0300',
		shortCode: 'ART',
	},
	{
		name: 'Coordinated Universal Time (GMT+00:00)',
		code: 'UTC',
		offset: '+0000',
		shortCode: 'UTC',
	},
	{
		name: 'London / Greenwich (GMT+00:00)',
		code: 'Europe/London',
		offset: '+0000',
		shortCode: 'GMT',
	},
	{
		name: 'Europe Central Time (GMT+02:00)',
		code: 'Europe/Berlin',
		offset: '+0200',
		shortCode: 'CET',
	},
	{
		name: 'Eastern European Time (GMT+02:00)',
		code: 'Europe/Helsinki',
		offset: '+0200',
		shortCode: 'EET',
	},
	{
		name: 'Moscow Standard Time (GMT+03:00)',
		code: 'Europe/Moscow',
		offset: '+0300',
		shortCode: 'MSK',
	},
	{
		name: 'Tehran (GMT+03:30)',
		code: 'Asia/Tehran',
		offset: '+0330',
		shortCode: 'IRST',
	},
	{
		name: 'Dubai (GMT+04:00)',
		code: 'Asia/Dubai',
		offset: '+0400',
		shortCode: 'GST',
	},
	{
		name: 'Kabul (GMT+04:30)',
		code: 'Asia/Kabul',
		offset: '+0430',
		shortCode: 'AFT',
	},
	{
		name: 'Pakistan Standard Time (GMT+05:00)',
		code: 'Asia/Karachi',
		offset: '+0500',
		shortCode: 'PKT',
	},
	{
		name: 'India Standard Time (GMT+05:30)',
		code: 'Asia/Kolkata',
		offset: '+0530',
		shortCode: 'IST',
	},
	{
		name: 'Kathmandu (GMT+05:45)',
		code: 'Asia/Kathmandu',
		offset: '+0545',
		shortCode: 'NPT',
	},
	{
		name: 'Bangladesh Standard Time (GMT+06:00)',
		code: 'Asia/Dhaka',
		offset: '+0600',
		shortCode: 'BST',
	},
	{
		name: 'Bangkok / Jakarta (GMT+07:00)',
		code: 'Asia/Bangkok',
		offset: '+0700',
		shortCode: 'ICT',
	},
	{
		name: 'China / Singapore (GMT+08:00)',
		code: 'Asia/Shanghai',
		offset: '+0800',
		shortCode: 'CST',
	},
	{
		name: 'Japan Standard Time (GMT+09:00)',
		code: 'Asia/Tokyo',
		offset: '+0900',
		shortCode: 'JST',
	},
	{
		name: 'Australian Eastern Standard Time (GMT+10:00)',
		code: 'Australia/Sydney',
		offset: '+1000',
		shortCode: 'AEST',
	},
	{
		name: 'Solomon Islands (GMT+11:00)',
		code: 'Pacific/Guadalcanal',
		offset: '+1100',
		shortCode: 'SBT',
	},
	{
		name: 'New Zealand (GMT+12:00)',
		code: 'Pacific/Auckland',
		offset: '+1200',
		shortCode: 'NZST',
	},
]
